/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublicStudentProfile } from '../../models/public-student-profile';

export interface UpdatePublicStatusStudentProfileCv$Params {
  studentId: string;
  shouldBePublic: boolean;
}

export function updatePublicStatusStudentProfileCv(http: HttpClient, rootUrl: string, params: UpdatePublicStatusStudentProfileCv$Params, context?: HttpContext): Observable<StrictHttpResponse<PublicStudentProfile>> {
  const rb = new RequestBuilder(rootUrl, updatePublicStatusStudentProfileCv.PATH, 'put');
  if (params) {
    rb.path('studentId', params.studentId, {});
    rb.path('shouldBePublic', params.shouldBePublic, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PublicStudentProfile>;
    })
  );
}

updatePublicStatusStudentProfileCv.PATH = '/studentprofile/{studentId}/publiccv/{shouldBePublic}';
